export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID, 
        authority: process.env.REACT_APP_AUTHORITY, 
        redirectUri: process.env.REACT_APP_DC_URL,
        postLogoutRedirectUri: process.env.REACT_APP_DC_URL
    },
    cache: {
        cacheLocation: "sessionStorage", // recommended for SPAs
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ["openid", "profile", "offline_access", process.env.REACT_APP_AUTHENTICATE],
};